import React, { useEffect, useRef, useState } from 'react'
import { Text as RNText, TextStyle, TouchableOpacity, ViewStyle } from 'react-native'

import { useStores } from '@trivie/core'
import { color, Text, Button } from '@trivie/ui-mobile'
import { useHistory } from 'react-router'
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied'
import { observer } from 'mobx-react-lite'
import { OtpEntry } from '@trivie/ui-web/components/otp-entry/otp-entry'

export const MagicLinkSentScreen = observer(() => {
  const { userStore } = useStores()
  const { email, setOtpNotFound, otpNotFound, evaluateOTC } = userStore

  const resend = () => userStore.sendMagicLink(email, 'com.trivie.engage.aha')
  const [otp, setOtp] = useState('')
  const pinRef = useRef<any>(null)
  const history = useHistory()

  useEffect(() => {
    setOtpNotFound(false)
  }, [])

  const login = () => {
    if (otp) {
      evaluateOTC(otp, email).then(async (data: any) => {
        if (userStore.status === 'error') {
          // history.replace('/magic')
        } else if (data.workspaces && data.workspaces.length > 1) {
          localStorage.removeItem('ml-error')
          history.replace('/workspaces')
        } else if (data.workspaces.length === 1) {
          localStorage.removeItem('ml-error')
          userStore.loginWorkspace(data.token, data.workspaces[0].access_code, () =>
            history.replace('/library'),
          )
        }
      })
    }
  }

  const onChange = (value: string) => {
    setOtpNotFound(false)
    setOtp(value)
  }

  return (
    <div style={ROOT} onClick={() => pinRef?.current.focus()}>
      <div style={CONTAINER}>
        <div style={CONTENT}>
          <div style={HEADER}>
            <Text style={HEADLINE} tx="Onboarding.Login.checkYourEmail" variant="headline" />
            <div style={{ flexDirection: 'row', display: 'flex' }}>
              <Text style={TAGLINE} tx="Onboarding.Login.toLogIn" />
              <Text style={EMAIL} text={email} />
            </div>
          </div>
          <div>
            <div style={{ flexDirection: 'column', display: 'flex', paddingBottom: 75 }}>
              <Text tx="Onboarding.Login.otpLogInTextLine1" />
              <Text tx="Onboarding.Login.otpLogInTextLine2" />
            </div>
            <OtpEntry onChange={onChange} />
          </div>
          <Button
            accessibilityRole="link"
            accessibilityLabel="Continue"
            disabled={otp.length !== 4}
            style={{
              ...SUBMIT,
              backgroundColor: otp.length === 4 ? color.blue : 'rgba(230, 230, 230, 1)',
            }}
            tx="Common.continue"
            onPress={login}
          />
          {otpNotFound && (
            <div style={ERROR_STATE}>
              <SentimentVeryDissatisfiedIcon
                htmlColor={color.red}
                style={{ marginRight: 12, fontSize: 20 }}
              />
              <span style={{ fontWeight: 700, fontSize: 12, color: 'rgba(255, 0, 0, 0.8)' }}>
                We don't recognize that code.&nbsp;
                <span style={{ fontWeight: 500 }}>
                  Please try again, or select Resend Code below or contact your administrator.
                </span>
              </span>
            </div>
          )}
          <Text style={NO_EMAIL}>
            {"Haven't received the email? "}
            <TouchableOpacity
              accessibilityRole="button"
              accessibilityLabel="Send Magic Link"
              onPress={resend}
            >
              <Text style={SEND_AGAIN} tx="Onboarding.Login.sendItAgain" />
            </TouchableOpacity>
            {', or email '}
            <a href={process.env.REACT_APP_SUPPORT}>
              <Text style={SUPPORT_EMAIL} text={process.env.REACT_APP_SUPPORT} />
            </a>
            {' to get in touch.'}
          </Text>
        </div>
      </div>
    </div>
  )
})

const SUBMIT: ViewStyle = {
  marginHorizontal: 20,
  alignSelf: 'center',
  width: 335,
  marginTop: 20,
  marginBottom: 28,
}
const ROOT: React.CSSProperties = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
}
const CONTAINER: React.CSSProperties = {
  flexDirection: 'column',
  flex: 1,
  display: 'flex',
  maxHeight: 576,
  justifyContent: 'space-evenly',
  // width: '33%',
  minWidth: 400,
  alignSelf: 'center',
}
const EMAIL: TextStyle = {
  textAlign: 'center',
  lineHeight: 20,
  fontWeight: '500',
  color: color.blue,
}
const SUPPORT_EMAIL: TextStyle = {
  fontWeight: '600',
  fontSize: 16,
  textDecorationLine: 'underline',
  color: color.blue,
}
const SEND_AGAIN: TextStyle = {
  fontWeight: '600',
  fontSize: 16,
  color: color.blue,
}
const NO_EMAIL: TextStyle = {
  lineHeight: 20,
  fontWeight: '400',
  color: color.black,
  fontSize: 16,
  textAlign: 'center',
  width: 350,
}
const CONTENT: React.CSSProperties = {
  height: '100%',
  flex: 1,
  backgroundColor: '#fff',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  alignSelf: 'center',
}
const HEADER: React.CSSProperties = {
  minWidth: 319,
  flexDirection: 'column',
  display: 'flex',
}
const TAGLINE: TextStyle = {
  color: color.black,
  textAlign: 'center',
}
const HEADLINE: TextStyle = { textAlign: 'center', marginBottom: 12 }
const ERROR_STATE: React.CSSProperties = {
  width: 349,
  height: 64,
  marginBottom: 25,
  borderRadius: 16,
  backgroundColor: 'rgba(249, 234, 234, 1)',
  paddingTop: 10,
  paddingBottom: 10,
  paddingRight: 20,
  display: 'flex',
  flexDirection: 'row',
  paddingLeft: 20,
  alignItems: 'center',
  alignSelf: 'center',
}
